export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: '看料社到底在做什么内容？',
    a: '看料社是一档由编辑部主导的深度内容栏目平台。我们不追着一件事的情绪跑，而是用深扒档案、脉络专栏、幕后再探与看料方法论四类栏目，把热点事件的时间线、关键节点、各方声音与背后机制铺开讲清，帮你看懂事件脉络。',
  },
  {
    q: '"小编深扒"和普通娱乐八卦有什么不同？',
    a: '普通八卦多为情绪化转载，讲"谁对谁错"；看料社的小编深扒更接近调查式编辑工作，讲"事情怎么发展、证据链是否完整、动机如何推演"。我们会刻意放慢节奏，标注信息来源，尽量把判断依据摊在读者面前。',
  },
  {
    q: '你们的内容更新频率如何？会在哪些栏目更新？',
    a: '看料社保持每周在四大栏目里滚动更新：深扒档案主打单点事件的纵深拆解，脉络专栏主打时间线与来龙去脉，幕后再探关注内容行业的运行机制，看料方法论则分享编辑部自己的看料技巧与核查清单。',
  },
  {
    q: '看料社如何保证内容的准确性与客观性？',
    a: '编辑部有一条基本纪律：能核实的才写进事实层，无法证实的只作"可能性推演"并明确标注。我们坚持先辨信源、再理时间、后查动机的三步法，并在关键论断处保留对一手信息的追溯空间，欢迎读者指正补充。',
  },
  {
    q: '读者可以投稿爆料或参与栏目共建吗？',
    a: '欢迎。如果你观察到了值得深挖的行业现象或事件线索，可以通过本站"联系我们"页面把材料发给我们。若线索经编辑部核实并采纳，我们会按来稿规范处理信源，也欢迎读者就已有栏目文章在讨论区补充不同视角。',
  },
];